import type { Messages } from "@prop/i18n";
import type en from "../en/risk";

export default {
  tabs: { programs: "Programas", risk: "Monitor de riesgo", breaches: "Incumplimientos", approvals: "Aprobaciones", fairplay: "Juego limpio", news: "Noticias" },
  markets: { fx: "FX / CFD", futures: "Futuros", crypto: "Cripto" },
  programs: {
    name: "Programa",
    market: "Mercado",
    published: "Publicada",
    draft: "Borrador",
    accounts: "Cuentas",
    none: "—",
    back: "Todos los programas",
    versions: "Versiones",
    version: "v{n}",
    status: { draft: "borrador", published: "publicada", retired: "retirada" },
    editDraft: "Editar como nuevo borrador",
    editor: "Borrador de la próxima versión",
    frozenNote: "Una versión publicada nunca cambia. Las cuentas ya compradas se quedan en su versión.",
    accountSize: "Tamaño de la cuenta, $",
    price: "Precio, $",
    listPrice: "Precio de lista, $",
    launchPricing: "Precios de lanzamiento",
    dayBoundary: "El día de trading termina a las",
    timezone: "Zona horaria",
    cmeSession: "Sesión de CME (17:00 Chicago)",
    leverage: "Apalancamiento",
    phase: "Fase {n}: {name}",
    funded: "Funded",
    target: "Objetivo de ganancia, %",
    dll: "Pérdida diaria, %",
    dllBase: "Base de la pérdida diaria",
    bases: { initial: "Balance inicial", day_start_balance: "Balance al inicio del día", day_start_equity: "Equity al inicio del día", max_day_start_balance_equity: "Máximo entre balance y equity al inicio del día" },
    dllAction: "Al alcanzar la pérdida diaria",
    actions: { fail: "Dar la cuenta por fallida", pause_until_next_day: "Pausar hasta el día siguiente" },
    ml: "Pérdida máxima, %",
    mlMode: "Tipo de pérdida máxima",
    modes: { static: "Estática", trailing_eod: "Trailing, al cierre del día", trailing_intraday_balance: "Trailing, balance intradía", trailing_equity_hwm: "Trailing, máximo histórico del equity" },
    lock: "El trailing se detiene en el balance inicial",
    minDays: "Días mínimos de trading",
    microHold: "Microscalping: operaciones mantenidas menos de, s",
    microShare: "Ganancia de microscalping, máx. % de la ganancia",
    streakDays: "Payout: días rentables seguidos",
    streakPct: "Cada uno de esos días al menos, % de la cuenta",
    streakConsecutive: "Esos días deben ser consecutivos",
    consistency: "Mejor día ≤ % de la ganancia",
    split: "Reparto de ganancias, %",
    json: "Todas las reglas (JSON)",
    jsonInvalid: "El JSON no es válido: {error}",
    saveDraft: "Guardar borrador",
    saved: "Borrador guardado",
    diff: "Cambios frente a la versión publicada",
    noChanges: "Sin cambios",
    publish: "Publicar",
    publishConfirm: "¿Publicar la versión {n}? Se vuelve inmutable y sale a la venta; la versión anterior se retira de las ventas nuevas.",
    publishedOk: "Versión {n} publicada",
    create: "Nuevo programa",
    slug: "Slug (a-z, 0-9, -)",
    family: "Familia",
    billing: "Facturación",
    billings: { one_time: "Pago único", monthly: "Mensual" },
    preview: "Resumen",
    summary: {
      target: "Objetivo {v}",
      dll: "pérdida diaria {v} ({base}, {action})",
      ml: "pérdida máxima {v} ({mode})",
      days: "{n} días de trading",
      daysBar: "{n} días de trading con ganancia ≥ {v} %",
      tradeLoss: "pérdida de una operación ≤ {v}, abierta o cerrada",
      window: "{h} h desde la primera operación",
      duration: "{n} días para superarla",
      maxDays: "como máximo {n} días de trading",
      inactivity: "{n} días sin operar cierran la cuenta",
      contracts: "hasta {n} contratos por instrumento",
      flat: "las posiciones se cierran a las {time}",
      weekend: "las posiciones FX / CFD se cierran el viernes a las 16:55 de Nueva York",
      news: "sin nuevas operaciones ±{n} min de noticias de alto impacto",
      consistency: "mejor día ≤ {v} %",
      microScalp: "operaciones de menos de {sec} s ≤ {v} % de la ganancia",
      streak: "payout tras {n} días rentables seguidos, cada uno ≥ {v}",
      payouts: "Payouts",
      split: "reparto {v} %",
    },
  },
  monitor: {
    title: "Cuentas según su cercanía a un incumplimiento",
    account: "Cuenta",
    trader: "Trader",
    phase: "Fase",
    status: "Estado",
    equity: "Equity",
    dllLeft: "Pérdida diaria restante",
    mlLeft: "Pérdida máxima restante",
    used: "Límite usado",
    empty: "Todavía no hay cuentas challenge ni funded",
  },
  states: {
    created: "creada",
    active: "activa",
    paused: "en pausa por hoy",
    phase_passed: "fase superada",
    pending_review: "en revisión",
    kyc_required: "KYC requerido",
    funded_pending: "activando funded",
    funded: "funded",
    breached: "infringida",
    failed: "fallida",
    expired: "vencida",
    suspended: "suspendida",
    closed: "cerrada",
    refunded: "reembolsada",
  },
  rules: { max_loss: "Pérdida máxima", daily_loss: "Pérdida diaria", consistency: "Consistencia", max_duration: "Duración máxima", inactivity: "Inactividad", max_trade_loss: "Pérdida máxima por operación", max_trading_days: "Días de trading agotados" },
  card: {
    back: "Volver",
    risk: "Riesgo actual",
    balance: "Balance",
    equity: "Equity",
    dll: "Límite de pérdida diaria",
    ml: "Piso de pérdida máxima",
    target: "Objetivo",
    days: "Días de trading",
    breaches: "Incumplimientos",
    noBreaches: "Sin incumplimientos",
    threshold: "Umbral",
    observed: "Observado",
    source: "Fuente del precio",
    positions: "Posiciones en el momento de la decisión",
    timeline: "Historial de estados",
    replay: "Reproducción",
    replayRun: "Reproducir con las reglas de la cuenta",
    whatIf: "Qué pasaría si",
    whatIfDll: "Pérdida diaria, %",
    whatIfMl: "Pérdida máxima, %",
    whatIfRun: "Reproducir con estas reglas",
    outcome: { breached: "Incumplimiento", passed: "Superada", open: "Sin decisión" },
    observations: "{n} observaciones registradas",
    manual: "Acción manual",
    event: "Acción",
    events: { suspend: "Suspender", unsuspend: "Reactivar", reinstate_from_breach: "Restablecer tras un incumplimiento (segunda aprobación)", force_pass: "Dar la fase por superada (segunda aprobación)", close: "Cerrar", penalty_reset: "Reiniciar con la penalización del 50 % en payouts" },
    penaltyDone: "Reiniciada: nueva cuenta {id}, payouts al 50 %",
    submit: "Enviar",
    pending: "Enviado para una segunda aprobación",
    reinstateHint: "Restablecer no corrige el balance. Tras un incumplimiento de pérdida máxima o diaria, la cuenta vuelve a incumplir en la siguiente verificación, salvo que añadas aquí una corrección (solo por un error de la plataforma).",
    adjustment: "Corrección de balance, USD (opcional, + o −)",
    adjustmentReason: "Motivo de la corrección",
  },
  approvals: {
    title: "Solicitudes de doble aprobación",
    account: "Cuenta",
    action: "Acción",
    reason: "Motivo",
    requestedBy: "Solicitado por",
    status: "Estado",
    approve: "Aprobar",
    reject: "Rechazar",
    statuses: { pending: "pendiente", approved: "aprobada", rejected: "rechazada", executed: "ejecutada" },
    ownRequest: "Es tu propia solicitud: la aprueba otra persona",
    adjustment: "corrección {v}",
    empty: "No hay solicitudes",
  },
  news: {
    title: "Calendario de noticias",
    lead: "Los eventos de alto impacto abren una ventana de noticias en los programas que la tienen (FX / CFD funded: ±2 min): no se puede abrir ni aumentar una posición en instrumentos de las divisas o mercados marcados; cerrar siempre está permitido. El motor lee el calendario cada 30 s.",
    at: "Hora (tu zona horaria)",
    name: "Evento",
    tags: "Divisas / mercados",
    tagsHint: "separados por comas: USD, EUR, XAU",
    impact: "Impacto",
    add: "Añadir evento",
    save: "Guardar",
    cancel: "Cancelar",
    edit: "Editar",
    remove: "Eliminar",
    empty: "No hay eventos en los próximos 30 días",
    impacts: { high: "alto", medium: "medio", low: "bajo" },
  },
  fairplay: {
    title: "Posiciones opuestas entre cuentas vinculadas",
    lead: "Largo en una cuenta y corto en otra, en el mismo instrumento y al mismo tiempo, entre cuentas de una misma persona, de personas con el mismo documento o vistas desde la misma red. La cobertura entre cuentas está prohibida: rechaza el payout por infracción de las reglas.",
    days: "Periodo",
    instrument: "Instrumento",
    long: "Largo",
    short: "Corto",
    links: "Vínculo",
    gap: "Separación al abrir",
    overlap: "Solapamiento",
    open: "abierta",
    empty: "No hay posiciones opuestas entre cuentas vinculadas en este periodo",
    link: { same_person: "misma persona", same_document: "mismo documento", shared_ip: "misma red" },
  },
} satisfies Messages<typeof en>;
